module.exports = __webpack_public_path__ + "img/1028.20eff0e8.png";